import React from 'react';
import {motion} from 'framer-motion';
import CosmoHeads from './CosmoHeads';

const ResultsCard = ({title, score, maxScore = 100, attentionLevel, description, date = new Date().toLocaleDateString()}) => {
  // Calcola la percentuale del punteggio
  const percentage = Math.round((score / maxScore) * 100);

  // Determina il colore in base al livello di attenzione
  const getBgColor = () => {
    switch (attentionLevel) {
      case 'highAttention': return 'bg-red-100 border-red-300';
      case 'attention': return 'bg-yellow-100 border-yellow-300';
      default: return 'bg-green-100 border-green-300';
    }
  };

  const getTextColor = () => {
    switch (attentionLevel) {
      case 'highAttention': return 'text-red-800';
      case 'attention': return 'text-yellow-800';
      default: return 'text-green-800';
    }
  };

  const getProgressColor = () => {
    switch (attentionLevel) {
      case 'highAttention': return 'bg-red-500';
      case 'attention': return 'bg-yellow-500';
      default: return 'bg-green-500';
    }
  };

  // Descrizioni brevi e concise per ogni test
  const getShortDescription = () => {
    switch (title) {
      case "PID-5-BF+": return "Moderata elevazione nei domini dell'affettività negativa e disinibizione.";
      case "Compass of Shame": return "Reazioni di vergogna nella norma rispetto alla popolazione generale.";
      case "LPF Scale 2.0": return "Compromissione nell'integrazione dell'identità e autodirezione.";
      default: return description?.substring(0, 100) || "Nessuna descrizione disponibile";
    }
  };

  return (
    <motion.div
      initial={{opacity: 0, y: 20}}
      animate={{opacity: 1, y: 0}}
      className={`${getBgColor()} border rounded-lg shadow-md p-5`}
    >
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className={`text-lg font-bold ${getTextColor()}`}>{title}</h3>
          <p className="text-gray-600 text-sm">{date}</p>
        </div>
        <CosmoHeads attentionLevel={attentionLevel} size="small" showLabel={false} />
      </div>

      <div className="mb-4">
        <div className="flex justify-between items-center mb-1">
          <span className="text-sm font-medium text-gray-700">Score</span>
          <span className={`text-sm font-medium ${getTextColor()}`}>{score}/{maxScore}</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div
            className={`h-2.5 rounded-full ${getProgressColor()}`}
            style={{width: `${percentage}%`}}
          ></div>
        </div>
      </div>

      <div className="mt-2">
        <p className="text-gray-700 text-sm">{getShortDescription()}</p>
      </div>
    </motion.div>
  );
};

export default ResultsCard;